export default __webpack_public_path__ + "static/media/ic_ftm_40.0c164311.svg";